import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./icon-button.css.ts.vanilla.css-mistica.js";
var t = "yqt1oe1 _1y2v1nfb9";
export { t as base };
